export default "__VITE_ASSET__B5vyFH2w__"